export const FeatureName: string = 'init';
